/**
 * Handler for the 'Skip to content' keyboard accessibility link. 
 * 
 * We have no convenient universal ID to link to in the page layout, 
 * so we use Javascript to find the first element in .page-wrapper 
 * that isn't a navigation, and set focus there.
 */

 const handleClick = () => {
    const wrapper = document.querySelector('.content-wrapper');

    if ( ! wrapper ) return;

    // Find the first element in .page-wrapper 
    // that isn't a nav
    for ( let i = 0; i < wrapper.children.length; i++ ) {
        const child = wrapper.children[i];

        // Skip over any navs or sticky containers
        if ( 
            child.tagName === 'HEADER'
            || child.tagName === 'NAV'
            || child.classList.contains('secondary-nav') 
            || child.classList.contains('stickyContainer') 
            || child.classList.contains('mega-menu-container')
        ) {
            continue;
        } else {
            // Set tab index so that we can focus on the element
            child.setAttribute('tabIndex', 0);

            // Set focus
            child.focus({
                preventScroll: false
            });

            // Scroll into view
            child.scrollIntoView();

            return;
        }
    }
};

const init = () => {
    const anchor = document.querySelector('#header__skip-to-content');
    
    if ( ! anchor ) return;

    anchor.addEventListener('click', handleClick);
};

export default {
    init
};